import { render, staticRenderFns } from "./WarekiSelect.vue?vue&type=template&id=072b680c&scoped=true&"
import script from "./WarekiSelect.vue?vue&type=script&lang=js&"
export * from "./WarekiSelect.vue?vue&type=script&lang=js&"
import style0 from "./WarekiSelect.vue?vue&type=style&index=0&id=072b680c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b680c",
  null
  
)

export default component.exports